<div [class.user]="message.sender === 'CUSTOMER'" class="chat-dialog-row">
  <div class="chat-dialog">
    <div class="chat-content">
      <div class="text-heading">{{ name }}</div>
      <div class="chat-text">
        <span [innerHTML]="message.description"></span>
        <ng-content></ng-content>
      </div>
      <div class="chat-time">
        <span>{{ message.datetime | date }}</span>
      </div>
    </div>
  </div>
</div>
